//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { createUserService, loadUsersService, updateUserService, updatePasswordService } from "../../services";
import { UsuariosContext } from "../../context/UsuariosContext";
import { LoadingContext } from "../../../../shared/context/LoadingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ModalEdit() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { users, setUsers } = useContext(UsuariosContext);
    const { formData, setFormData } = useContext(UsuariosContext);
    const { isEditing, setIsEditing } = useContext(UsuariosContext);
    const { userIdEdited, setUserIdEdited } = useContext(UsuariosContext);
    const { passwordOnly, setPasswordOnly } = useContext(UsuariosContext);
    const { isModalOpen, setIsModalOpen } = useContext(UsuariosContext);
    const { status, setStatus } = useContext(UsuariosContext);
    const { isLoadind, setIsLoading} = useContext(LoadingContext);



    //-------------- FUNÇÃO ASSÍNCRONA HANDLE SAVE USER --------------//
    // Responsável por atualizar uma nova senha, ou atualizar um usuário ou criar um Novo Usuário no Banco de Dados via API
    const handleSaveUser = async () => {

        if (passwordOnly) {
            await updatePasswordService(userIdEdited, formData.senha);
        } else {
            const payload = {
                nome: formData.nome,
                email: formData.email,
                senha: formData.senha
            };

            if (isEditing) {
                await updateUserService(userIdEdited, payload);
            } else {
                await createUserService(payload);
            }
        }

        setIsModalOpen(false);
        handleRefreshUsers();

    };



    //-------------- FUNÇÃO ASSÍNCRONA HANDLE REFRESH USERS --------------//
    // Responsável por requisitar os usuário à API
    async function handleRefreshUsers() {
        setIsLoading(true);
        const response = await loadUsersService(status);
        if (response) {
            setUsers(response.data);
        }
        setIsLoading(false);
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* MODAL DE EDIÇÃO */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-surface-2 p-6 rounded-xl w-full max-w-md border border-white/[0.08]">
                        <h2 className="text-xl font-bold mb-4">
                            {passwordOnly ? "Alterar Senha" : isEditing ? "Editar Usuário" : "Novo Usuário"}
                        </h2>

                        {!passwordOnly && (
                            <>
                                <input
                                    type="text"
                                    placeholder="Nome"
                                    value={formData.nome}
                                    onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                                    className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full mb-3"
                                />
                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full mb-3"
                                />
                            </>
                        )}

                        <input
                            type="password"
                            placeholder="Senha"
                            value={formData.senha}
                            onChange={(e) => setFormData({ ...formData, senha: e.target.value })}
                            className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full mb-3"
                        />

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="bg-surface-3 hover:bg-surface-4 px-4 py-2 rounded"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleSaveUser}
                                className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                            >
                                Salvar
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}